import React from "react";
import {OrbitComponent} from "../../../base-components/orbit-component/orbit-component";
import {LoadingDotsComponent} from "../../../../basic-components/loading-dots/loading-dots.component";
import {observer} from "mobx-react";

export const WebAppGameLoadingIndicatorComponent = observer(class WebAppGameLoadingIndicatorComponent extends OrbitComponent {
    render() {
        return (
            <LoadingDotsComponent/>
        );
    }
});